<script>
    import RecipeService from "../server/service/RecipeService";

    export let params = undefined;
</script>

{#await (RecipeService.getData(params.id))}
    <p>Loading...</p>
{:then recipe}
    <article class="recipe">
        <h1>{recipe.title}</h1>
        <p>{recipe.created}</p>
        <p>{recipe.description}</p>
        <ul>
            {#each recipe.ingredients as ingredient}
                <li>{ingredient.name}</li>
            {/each}
        </ul>
    </article>
{:catch error}
    <p style="color: red">{error.message}</p>
{/await}
